module.exports = __webpack_public_path__ + "img/Auditorium.176ede19.jpg";